import {z} from 'zod';

export default z.object({
    html: z.string()
})
